// swiper-collection
if (!customElements.get('swiper-collection-component')) {
  customElements.define(
    'swiper-collection-component',
    class SwiperCollectionComponent extends HTMLElement {
      constructor() {
        super();
        this.rafId = null;
        this.observer = null;
        this.sectionId = this.dataset.id;
        this.resizeHeightBound = debounce(this.resizeHeight.bind(this), 200);
      }

      connectedCallback() {
        this.observeField();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.swiper) this.swiper.destroy(true, true);
        window.removeEventListener('resize', this.resizeHeightBound);
      }

      observeField() {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.wakeUpCall();
              this.observer.disconnect();
            }
          });
        }, { rootMargin: '300px' }); // Start loading 300px before user arrives

        this.observer.observe(this);
      }

      wakeUpCall() {
        if (!this.swiperElements.wrapper && this.dataset.swiper === 'true') {
          const swiperTemplate = this.querySelector('template');

          if (!swiperTemplate) return;
          const swiperTemplateParent = swiperTemplate.parentElement;
          const swiperTemplateContent = swiperTemplate.content?.cloneNode(true);

          if (!swiperTemplateContent) return;
          this.rafId = requestAnimationFrame(() => {
            swiperTemplateParent.appendChild(swiperTemplateContent), swiperTemplateParent.querySelector('.skeleton-grid')?.remove();

            requestAnimationFrame(() => {
              this.initSwiper();
              swiperTemplate?.remove();
            });
          });
        };

        if (this.swiperElements.wrapper && this.dataset.swiper === 'true') this.initSwiper();
      }

      initSwiper() {
        if (this.swiper) this.swiper.destroy(true, true);

        this.swiperOptions = {
          slidesPerView: this.swiperColumns.mobile,
          spaceBetween: this.swiperSpacings.mobile,
          freeMode: {
            enabled: true,
            sticky: false,
            momentumRatio: 1.25,
            momentumVelocityRatio: 1.5,
          },
          breakpoints: {
            750: {
              slidesPerView: this.swiperColumns.tablet,
              spaceBetween: this.swiperSpacings.tablet,
            },
            990: {
              slidesPerView: this.swiperColumns.desktop,
              spaceBetween: this.swiperSpacings.desktop,
            },
          },
          watchSlidesProgress: true
        }

        this.swiperScrollbar();
        this.swiperPagination();
        this.swiperNavigations();

        this.swiper = new Swiper(this.swiperElements.wrapper, this.swiperOptions);
      }

      swiperScrollbar() {
        if (this.swiperElements.scrollbar) {
          this.swiperOptions.scrollbar = {
            hide: true,
            draggable: true,
            el: this.swiperElements.scrollbar,
          }
        }
      }

      swiperPagination() {
        if (this.swiperElements.pagination) {
          this.swiperOptions.pagination = {
            clickable: true,
            dynamicBullets: true,
            el: this.swiperElements.pagination,
          }
        }
      }

      swiperNavigations() {
        if (this.swiperElements.next && this.swiperElements.prev) {
          this.swiperOptions.navigation = {
            nextEl: this.swiperElements.next,
            prevEl: this.swiperElements.prev,
          }
        }
      }

      resizeHeight() {
        const wrapperEl = this.swiperElements.wrapper.querySelector('.swiper-wrapper');
        if (!wrapperEl) return;
        const swiperWrapper = wrapperEl.getBoundingClientRect();
        this.style.setProperty('--swiper-slides-height', `${swiperWrapper.height}px`);
      }

      get swiperElements() {
        return {
          wrapper: this.querySelector(`[id^="SwiperCollection-${this.sectionId}"]`),
          prev: this.querySelector(`[id^="SwiperCollection-prev-${this.sectionId}"]`),
          next: this.querySelector(`[id^="SwiperCollection-next-${this.sectionId}"]`),
          pagination: this.querySelector(`[id^="SwiperCollection-pagination-${this.sectionId}"]`),
          scrollbar: this.querySelector(`[id^="SwiperCollection-scrollbar-${this.sectionId}"]`),
        };
      }

      get swiperColumns() {
        return {
          desktop: parseFloat(this.dataset.columnsDesktop) || 4,
          tablet: parseFloat(this.dataset.columnsTablet) || 2,
          mobile: parseFloat(this.dataset.columnsMobile) || 1,
        };
      }

      get swiperSpacings() {
        return {
          desktop: parseFloat(this.dataset.spaceDesktop) || 20,
          tablet: parseFloat(this.dataset.spaceTablet) || 15,
          mobile: parseFloat(this.dataset.spaceMobile) || 10,
        };
      }
    }
  );
}